export const getPerformanceMark = (): number => {
	if (!performance) {
		return 0;
	}
	return Math.trunc(performance.now());
};

type Timestamped = {
	elapsed: number;
};

export type UserInteractedEvent = {
	type: 'user-interacted';
};

export type NavigationTimingEvent = {
	duration: number;
	transferSize: number;
	type: 'navigation-timing';
};

export type ResourceTimingEvent = {
	duration: number;
	initiatorType: string;
	start: number;
	transferSize: number;
	type: 'resource-timing';
};

export type LayoutShiftScoreEvent = {
	inputFlag: boolean;
	score: number;
	timestamp: number;
	type: 'dcls-score';
};

/**
 * While useHeightObserver will be recording height values over a time period,
 * measuredHeight is a parameter stored on the extension object when the user configures
 * a macro. This can occur during custom or side panel configuration updates. The viewportHeight
 * is a parameter provided by the vendor through forge/confluence-bridge. Both values can
 * be used as comparison for accuracy with height.
 */
export type ResizeEvent = {
	height: number;
	measuredHeight?: string;
	type: 'resized';
	viewportHeight?: string;
};

export type ProductRequestedEvent = {
	authDuration: number;
	duration: number;
	type: 'product-api-requested';
};

export type ProductRequestInitiatedEvent = {
	type: 'product-api-request-initiated';
};

export type PermissionRequestedEvent = {
	authDuration: number;
	duration: number;
	type: 'permission-api-requested';
};

export type PermissionRequestInitiatedEvent = {
	type: 'permission-api-request-initiated';
};

export type ResolverInvokeInitiatedEvent = {
	type: 'resolver-invoke-initiated';
};

export type ResolverInvokedEvent = {
	authDuration: number;
	duration: number;
	type: 'resolver-invoked';
};

export type FCPSnapshotEvent = {
	start: number;
	type: 'fcp-snapshot';
};

export type LCPSnapshotEvent = {
	size: number;
	start: number;
	type: 'lcp-snapshot';
};

export type PageHoldReleased = {
	type: 'page-hold-released';
};

export type EmitReadyEvent = {
	type: 'emit-ready-event';
};

export type SerialisableValue =
	| string
	| number
	| boolean
	| null
	| SerialisableValue[]
	| { [key: string]: SerialisableValue };

export type UFOFrameEvent<
	TPayload extends Record<string, SerialisableValue> = Record<string, SerialisableValue>,
> = {
	name: string;
	payload: TPayload;
	type: 'ufo-event';
};

export type AppPerformanceProfilingEvent = Timestamped &
	(
		| ResizeEvent
		| ProductRequestedEvent
		| ProductRequestInitiatedEvent
		| PermissionRequestedEvent
		| PermissionRequestInitiatedEvent
		| UserInteractedEvent
		| NavigationTimingEvent
		| ResolverInvokedEvent
		| ResolverInvokeInitiatedEvent
		| ResourceTimingEvent
		| LayoutShiftScoreEvent
		| FCPSnapshotEvent
		| LCPSnapshotEvent
		| PageHoldReleased
		| EmitReadyEvent
		| UFOFrameEvent
	);
